import { application } from './application'
import FiltersDrawerController from './filters_drawer_controller'
import FilterPreviewController from './filter_preview_controller'
import ResultsScrollController from './results_scroll_controller'
import StickyArticleRecipesController from './sticky_article_recipes_controller'
import RecipeRatingController from './recipe_rating_controller'

application.register('filters-drawer', FiltersDrawerController)
application.register('filter-preview', FilterPreviewController)
application.register('results-scroll', ResultsScrollController)
application.register('sticky-article-recipes', StickyArticleRecipesController)
application.register('recipe-rating', RecipeRatingController)
